import { ComponentType } from '@angular/cdk/portal';
import { Component, ElementRef, EventEmitter, Inject, OnDestroy, OnInit, Output, ViewChild, Renderer2, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { CalendarDataService } from '../../../services/calendar-data.service';
import { RefreshService } from '../../../services/refresh.service';
import { DialogService } from '../../../services/dialog.service';
import { EntityRESTService } from '../../../services/entity-rest.service';
import { UtilityService } from '../../../services/utility.service';
import { FieldsService } from '../../../services/fields.service';
import { DrupalRESTService } from '../../../services/drupal-rest.service';
import { TaxonomyService } from '../../../services/taxonomy.service';
import { AuthRESTService } from '../../../services/auth-rest.service';
import { AuthService } from '../../../services/auth.service';
import { MenuRESTService } from '../../../services/menu-rest.service';
import { RouteEventsService } from '../../../route-events.service';
import { PermissionsService } from '../../../services/permissions.service';
import { ConfigPagesService } from '../../../services/config-pages.service';
import { PackagesService } from '../../../services/packages.service';
import { UserService } from '../../../services/user.service';
import { StudioConfigService } from '../../../services/studio-config.service';
import { LocalizationService, CountryDateFormats } from '../../../services/localization.service';
import { ComponentRefreshService } from '../../../services/component-refresh.service';
import { StudentDashboardWrapperComponent } from '../../student/student-dashboard-wrapper/student-dashboard-wrapper.component';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';
import { CancelFutureAppointmentComponent } from '../cancel-future-appointment/cancel-future-appointment.component';
import { CancelRescheduleComponent } from '../cancel-reschedule/cancel-reschedule.component';
import { EnrollmentEntityComponent } from '../enrollment-entity/enrollment-entity.component';
import { EventGroupLessonEntityComponent } from '../event-group-lesson-entity/event-group-lesson-entity.component';
import { EventLessonEntityComponent } from '../event-lesson-entity/event-lesson-entity.component';
import { EventSchedulesEntityComponent } from '../event-schedules-entity/event-schedules-entity.component';
import { EventServicesEntityComponent } from '../event-services-entity/event-services-entity.component';
import { PaymentsEntityComponent } from '../payments-entity/payments-entity.component';
import { PostLessonComponent } from '../post-lesson/post-lesson.component';
import { CancelFutureServiceComponent } from '../cancel-future-service/cancel-future-service.component';
import { BaseComponent } from '../base-form/base-form.component';
import { UpdateStatusGroupLessonComponent } from '../update-status-group-lesson/update-status-group-lesson.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { PhoneNumberService } from '../../../services/phone-number.service';
import { StudioTaxService, StudioTaxMode } from '../../../services/studio-tax.service';
import { LoggerService } from '../../../services/logger.service';


@Component({
  selector: 'app-appointment-details',
  templateUrl: './appointment-details.component.html',
  styleUrls: [
    './appointment-details.component.css',
    '../../../../app.component.css',
  ]
})
export class AppointmentDetailsComponent extends BaseDialogComponent implements OnInit, OnDestroy {

  private calendarDataService: CalendarDataService;

  constructor(
    _dialogRef: MatDialogRef<unknown>,
    _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) _injectedDialogData: any,
    _refreshService: RefreshService,
    _dialogService: DialogService,
    _entityRESTService: EntityRESTService,
    _utilityService: UtilityService,
    _fieldsService: FieldsService,
    _drupalRESTService: DrupalRESTService,
    _taxonomyService: TaxonomyService,
    _router: Router,
    _activatedRoute: ActivatedRoute,
    _authRESTService: AuthRESTService,
    _authService: AuthService,
    _menuRESTService: MenuRESTService,
    _formBuilder: FormBuilder,
    _routeEventsService: RouteEventsService,
    _permissionsService: PermissionsService,
    _renderer2: Renderer2,
    _configPages: ConfigPagesService,
    _packagesService: PackagesService,
    _snackBar: MatSnackBar,
    _userRESTService: UserService,
    _el: ElementRef,
    _changeDetectorRef: ChangeDetectorRef,
    _sanitizer: DomSanitizer,
    _studioConfigService: StudioConfigService,
    _componentRefreshService: ComponentRefreshService,
    _translateService: TranslateService,
    calendarDataService: CalendarDataService,
    phoneNumberService: PhoneNumberService,
    private _localizationService: LocalizationService,
    private _studioTaxService: StudioTaxService
  ) {
    super(
      _dialogRef,
      _dialog,
      _injectedDialogData,
      _refreshService,
      _dialogService,
      _entityRESTService,
      _utilityService,
      _fieldsService,
      _drupalRESTService,
      _taxonomyService,
      _router,
      _activatedRoute,
      _authRESTService,
      _authService,
      _menuRESTService,
      _formBuilder,
      _routeEventsService,
      _permissionsService,
      _renderer2,
      _configPages,
      _packagesService,
      _snackBar,
      _userRESTService,
      _el,
      _changeDetectorRef,
      _sanitizer,
      _studioConfigService,
      _componentRefreshService,
      _translateService,
      phoneNumberService
    );
    this.calendarDataService = calendarDataService;
    // Exclusive-tax studios see the next-payment chip incl. tax.
    this.studioSubscriptions.add(this._studioTaxService.getTaxMode().subscribe(mode => this.taxMode = mode));

    this.studioSubscriptions.add(this._studioConfigService.getCountryCode().subscribe(country => {
      this.dateFormats = this._localizationService.getDateFormatsForCountry(country);
    }));
  }

  // Tax mode and studio config are app-lifetime streams; released on destroy so
  // each closed appointment dialog can be garbage collected.
  private studioSubscriptions = new Subscription();

  override ngOnDestroy(): void {
    this.studioSubscriptions.unsubscribe();
    super.ngOnDestroy();
  }

  formatUpcomingLesson(value: any): string {
    if (!value || !this.dateFormats) return '';
    const parsed = moment(value);
    if (!parsed.isValid()) return value.toString();
    return parsed.format(this.dateFormats.shortDateTimeFormatMoment);
  }

  formatUpcomingLessonDate(value: any): string {
    if (!value) return '';
    const parsed = moment(value);
    if (!parsed.isValid()) return value.toString();
    return parsed.format('MMM D, YYYY');
  }

  formatUpcomingLessonTime(value: any): string {
    if (!value) return '';
    const parsed = moment(value);
    if (!parsed.isValid()) return '';
    return parsed.format('h:mm A');
  }

  isCurrentLesson(value: any): boolean {
    if (!value) return false;
    // The dialog's lesson can come from several places. Try them in order
    // of reliability: eventDetails.startDate (used by processEventDetails),
    // then field_date_and_time, then the calendar event's start.
    const ed = this.injectedDialogData?.event?._def?.extendedProps?.eventDetails;
    let lessonDt: any = null;
    if (ed?.startDate?.join) {
      lessonDt = ed.startDate.join(' ');
    } else if (ed?.data?.field_date_and_time) {
      lessonDt = ed.data.field_date_and_time;
    } else if (this.injectedDialogData?.event?.start) {
      lessonDt = this.injectedDialogData.event.start;
    }
    if (!lessonDt) return false;
    // upcomingEventList items can be a string OR an object with .date / .dateFormatted.
    const compareVal = (typeof value === 'object' && value !== null)
      ? (value.date || value.dateFormatted || '')
      : value;
    if (!compareVal) return false;
    return moment(compareVal).isSame(moment(lessonDt), 'minute');
  }

  upcomingLessonsExpanded: boolean = false;

  // Whether any reminder actually went out, derived from the audit trail
  // (the field_24/48/72_hour_notification_sent flags on the event are stale
  // and miss grouped sends). Excludes opt_out rows since those aren't sends.
  get reminderActuallySent(): boolean {
    if (!Array.isArray(this.notificationHistory)) return false;
    return this.notificationHistory.some(n =>
      n?.notification_type !== 'opt_out' &&
      (n?.status === 'sent' || n?.status === 'delivered')
    );
  }

  // The current lesson + upcoming lessons, with "current" guaranteed at index 0
  // so the highlighted row always renders even when the API's upcomingEventList
  // excludes the lesson currently open in the dialog.
  get displayLessonList(): any[] {
    const ed = this.injectedDialogData?.event?._def?.extendedProps?.eventDetails;
    let currentDt: any = null;
    if (ed?.startDate?.join) {
      currentDt = ed.startDate.join(' ');
    } else if (ed?.data?.field_date_and_time) {
      currentDt = ed.data.field_date_and_time;
    } else if (this.injectedDialogData?.event?.start) {
      currentDt = this.injectedDialogData.event.start;
    }

    const list: any[] = Array.isArray(this.upcomingEventList) ? [...this.upcomingEventList] : [];

    if (currentDt) {
      const alreadyHas = list.some(v => {
        const vDt = (typeof v === 'object' && v !== null) ? (v.date || v.dateFormatted || '') : v;
        if (!vDt) return false;
        return moment(vDt).isSame(moment(currentDt), 'minute');
      });
      if (!alreadyHas) {
        list.unshift(currentDt);
      }
    }
    return list;
  }

  @Output() eventDeleted = new EventEmitter<void>();

  entityID = this.injectedDialogData?.event?._def?.extendedProps?.entityId;
  eventData = this.injectedDialogData?.event?._def?.extendedProps?.eventDetails;
  attendeesID = this.injectedDialogData?.event?._def?.extendedProps?.eventDetails?.studentsDashboardStatus?.[0]?.attendees_id;
  studentName = this.injectedDialogData?.event?._def?.extendedProps?.eventDetails.studentsDashboardStatus?.[0]?.name;
  eventID = this.injectedDialogData?.event?._def?.extendedProps?.eventDetails.studentsDashboardStatus?.[0]?.entity_id;
  status = this.injectedDialogData?.event?._def?.extendedProps?.eventDetails.studentsDashboardStatus?.[0]?.status;
  appointmentType = this.injectedDialogData?.event?._def?.extendedProps?.appointmentType;
  studioInformationConfig: any;
  eventEntityData: Object;
  flag2: boolean;
  flag1: boolean;
  isLoading = false;
  activeButton: 'email' | 'save' | null = null;
  // Track if we're on the lesson blocks tab
  isLessonBlocksTabActive = false;
  // Details is the first/initial tab in the dialog
  isDetailsTabActive = true;
  // Track convert lesson processing state
  isConvertingLesson = false;

  // Store refreshed event data separately since injectedDialogData is readonly
  refreshedEventData: any;
  isRefreshing: boolean = false;

  // Store refreshable data separately (since injectedDialogData is readonly).
  // Seeded from the injected event here so the template can bind to these
  // exclusively. Reading injectedDialogData directly in the template shows
  // stale data after an edit, because it is never updated by a refresh.
  studentInfo: any = this.injectedDialogData?.event?._def?.extendedProps?.studentInfo || {};
  instructorName: string = this.injectedDialogData?.event?._def?.extendedProps?.instructorName || '';
  enrollmentInfo: any = this.injectedDialogData?.event?._def?.extendedProps?.enrollmentInfo || {};
  upcomingEventList: any[] = this.injectedDialogData?.event?._def?.extendedProps?.upcomingEventList || [];
  private dateFormats: CountryDateFormats;
  isStanding: boolean = this.injectedDialogData?.event?._def?.extendedProps?.isStanding || false;
  isConfirmed: boolean = this.injectedDialogData?.event?._def?.extendedProps?.isConfirmed || false;
  notificationSent: boolean = false;
  eventNotes: string = this.injectedDialogData?.event?._def?.extendedProps?.eventDetails?.data?.field_notes || '';
  studentDetails: any = this.injectedDialogData?.event?._def?.extendedProps?.studentDetails || {};

  // Reminder history fetched on dialog open. Kept separate from injected data
  // because it requires a backend lookup against the notifications audit table.
  notificationHistory: any[] = [];
  notificationHistoryLoading: boolean = false;
  notificationHistoryError: string = '';

  override lessonBlockForm = this._formBuilder.group({
    field_material_covered: [null],
    field_comments: [null],
    field_lesson_rating: [null],
  });

  detectSignatureInstructor: boolean;
  detectSignatureStudent: boolean;

  @ViewChild('SignatureStudent') signatureStudent: ElementRef<HTMLCanvasElement>;
  @ViewChild('SignatureInstructor') signatureInstructor: ElementRef<HTMLCanvasElement>;
  @ViewChild(BaseComponent) baseComponent: BaseComponent;
  @ViewChild('updateStatusGroupLesson') updateStatusGroupLesson: UpdateStatusGroupLessonComponent;

  // Component refs
  EventLessonEntityComponent = EventLessonEntityComponent;
  EventServicesEntityComponent = EventServicesEntityComponent;
  PaymentEntityComponent = PaymentsEntityComponent;
  EventScheduleEntityComponent = EventSchedulesEntityComponent;
  EventGroupLessonEntityComponent = EventGroupLessonEntityComponent;
  CancelRescheduleComponent = CancelRescheduleComponent;
  PostLessonComponent = PostLessonComponent;
  EnrollmentEntityComponent = EnrollmentEntityComponent;
  CancelFutureAppointmentComponent = CancelFutureAppointmentComponent;
  StudentDashboardWrapperComponent = StudentDashboardWrapperComponent;
  CancelFutureServiceComponent = CancelFutureServiceComponent;
  BaseComponent = BaseComponent;


  override ngAfterViewInit() {
    LoggerService.log('this.injectedDialogData', this.injectedDialogData);

    // Initialize all refreshable properties with the original data
    this.initializeRefreshableData();

    // Initialize signatures with a slight delay to ensure DOM is ready
    setTimeout(() => {
      LoggerService.log('Initializing signature pads');
      // Check if signature elements exist before initializing
      if (this.signatureStudent?.nativeElement) {
        LoggerService.log('Student signature canvas found');
        this.signatureInit(this.signatureStudent, 'student');
      } else {
        LoggerService.log('Student signature canvas not found yet');
      }

      if (this.signatureInstructor?.nativeElement) {
        LoggerService.log('Instructor signature canvas found');
        this.signatureInit(this.signatureInstructor, 'instructor');
      } else {
        LoggerService.log('Instructor signature canvas not found yet');
      }
    }, 500);

    this._drupalRESTService.httpGET('/api_rest/v1/getStudioInformation')
      .subscribe(data => {
        this.studioInformationConfig = data;
        LoggerService.log('Studio Information:', this.studioInformationConfig);
      }, error => {
        LoggerService.error('Error fetching studio information:', error);
      });

    if (this.injectedDialogData?.event?._def?.extendedProps?.appointmentType == 'lesson') {
      // Load lesson data once and use it for both purposes
      this.loadLessonData(this.entityID).subscribe((data) => {
        this.eventEntityData = data;
        LoggerService.log('eventEntityData', this.eventEntityData);

        // Set form values if needed after data is loaded
        // this.setFormValues(this.lessonBlockForm);
      });

      // Get entity data if needed for additional information
      this.getEntity('events', 'lesson', this.entityID, null);

      // Reminder history loads in its own request so the dialog opens fast
      // and the history panel shows a loading state until results arrive.
      this.loadNotificationHistory(this.entityID);
    }
  }

  loadNotificationHistory(eventID: string) {
    if (!eventID) return;
    this.notificationHistoryLoading = true;
    this.notificationHistoryError = '';
    this.notificationHistory = [];
    this._drupalRESTService.httpGET('/api_rest/v1/getEventNotifications?eventID=' + eventID)
      .subscribe(
        (response: any) => {
          this.notificationHistoryLoading = false;
          if (response?.error) {
            this.notificationHistoryError = response.error;
            return;
          }
          this.notificationHistory = response?.notifications || [];
        },
        (error) => {
          this.notificationHistoryLoading = false;
          this.notificationHistoryError = 'Could not load reminder history';
          LoggerService.error('Error loading notification history:', error);
        }
      );
  }

  /**
   * Initialize all refreshable data properties from the injected dialog data
   */
  private initializeRefreshableData(): void {
    const extProps = this.injectedDialogData?.event?._def?.extendedProps;

    if (extProps) {
      this.studentInfo = extProps.studentInfo || {};
      this.instructorName = extProps.instructorName || '';
      this.enrollmentInfo = extProps.enrollmentInfo || {};
      this.upcomingEventList = extProps.upcomingEventList || [];
      this.isStanding = extProps.isStanding || false;
      this.isConfirmed = extProps.isConfirmed || false;
      this.notificationSent = this.toBool(extProps.field_24_hour_notification_sent) ||
                             this.toBool(extProps.field_48_hour_notification_sent) ||
                             this.toBool(extProps.field_72_hour_notification_sent);
      this.eventNotes = extProps.eventDetails?.data?.field_notes || '';
      this.studentDetails = extProps.studentDetails || {};
    }
  }

  /**
   * Utility to open dialogs with a default configuration.
   *
   * @param formName
   * @param dialogConfig
   */
  openDialog(component: ComponentType<unknown>, dialogConfig: { height: string, width: string, closeOnNavigation?: boolean, data?: {} }, data) {
    // Add a flag to indicate this was opened from appointment details
    if (component === this.StudentDashboardWrapperComponent) {
      data = { ...data, openedFromAppointmentDetails: true };
      LoggerService.log('[AppointmentDetails] Opening StudentDashboard with data:', data);
    }

    let dialogRef = this._dialogService.openDialog(component, dialogConfig ?? "defaultWithData", {
      data,
    }).afterClosed().subscribe(result => {
      LoggerService.log('[AppointmentDetails] Dialog closed with result:', result);

      // Check if we need to refresh based on the component that was closed
      let shouldRefresh = false;

      // Student Dashboard with changes
      if (component === this.StudentDashboardWrapperComponent && result?.dataChanged) {
        LoggerService.log('[AppointmentDetails] Data changed detected in Student Dashboard');
        shouldRefresh = true;
      }

      // Post Lesson component (always refresh after posting a lesson)
      if (component === this.PostLessonComponent) {
        LoggerService.log('[AppointmentDetails] Post Lesson completed');
        shouldRefresh = true;
      }

      // Cancel/Reschedule components (refresh if action was taken)
      if ((component === this.CancelRescheduleComponent ||
           component === this.CancelFutureAppointmentComponent ||
           component === this.CancelFutureServiceComponent) && result) {
        LoggerService.log('[AppointmentDetails] Cancel/Reschedule action completed');
        shouldRefresh = true;
      }

      if (shouldRefresh) {
        LoggerService.log('[AppointmentDetails] Refreshing appointment data...');
        this.refreshAppointmentData();
      }
    });
  }

  override openEntityComponent(component: ComponentType<unknown>, eckType: any, bundle: any, action: any, EntityID?: any, fieldsData?: {}) {
    // Enrollment form needs the wider dialog to match the "Add Enrollment" button on the Enrollment List.
    const dialogConfig = component === this.EnrollmentEntityComponent ? "enrollmentFormWithData" : "defaultWithData";
    const dialogRef = this._dialogService.openDialog(component, dialogConfig, {
      data: {
        EntityID: EntityID ?? '',
        eckType: eckType ?? '',
        bundle: bundle ?? '',
        action: action ?? '',
        fieldsData: fieldsData ?? '',
      },
    });

    // Add afterClosed handler to refresh data when returning from edit dialogs
    dialogRef.afterClosed().subscribe(result => {
      LoggerService.log('[AppointmentDetails] Entity dialog closed with result:', result);

      // For delete actions, close the appointment details dialog after successful deletion
      if (action === 'delete') {
        LoggerService.log('[AppointmentDetails] Delete action completed, closing appointment details and refreshing calendar');
        this._componentRefreshService.refreshCalendar();
        this.closeDialog({ refreshed: true });
        return;
      }

      // Refresh data when returning from edit/create dialogs for various entity types
      const shouldRefresh = (
        component === this.EventLessonEntityComponent ||
        component === this.EventServicesEntityComponent ||
        component === this.EventGroupLessonEntityComponent ||
        component === this.EventScheduleEntityComponent ||
        component === this.PaymentEntityComponent ||
        component === this.EnrollmentEntityComponent
      ) && (action === 'edit' || action === 'create');

      if (shouldRefresh) {
        LoggerService.log('[AppointmentDetails] Refreshing after entity edit/create');
        this.refreshAppointmentData();
      }
    });

    return dialogRef;
  }

  nextPaymentOnly(field_scheduled_payments?) {
    if (field_scheduled_payments) {
      let only1 = false;
      return field_scheduled_payments.filter((field_scheduled_payment) => {
        if (only1 == false && moment(field_scheduled_payment.field_payment_date).isSameOrAfter(moment().subtract(1, "days"))) {
          only1 = true;
          return true;
        }
      })
    }
  }

  // Single upcoming scheduled payment for the enrollment, used to render
  // Payment Due / Date Due chips in the appointment header.
  get nextScheduledPayment(): any {
    const list = this.enrollmentInfo?.field_scheduled_payments
      || this.injectedDialogData?.event?._def?.extendedProps?.enrollmentInfo?.field_scheduled_payments;
    const filtered = this.nextPaymentOnly(list);
    return Array.isArray(filtered) && filtered.length > 0 ? filtered[0] : null;
  }

  /** Studio tax mode; null until loaded. */
  taxMode: StudioTaxMode | null = null;

  /**
   * What is still owed on the next scheduled payment: unpaid pre-tax amount,
   * plus that share of the row's stored tax when the studio's taxes are
   * exclusive (Canadian GST/HST/PST). Rows store field_payment_amount +
   * field_tax_amount; field_amount_paid is pre-tax gross.
   */
  get nextScheduledPaymentRemaining(): { amount: number; tax: number; total: number } | null {
    const row = this.nextScheduledPayment;
    if (!row) return null;
    const amount = parseFloat(row.field_payment_amount) || 0;
    const paid = parseFloat(row.field_amount_paid) || 0;
    const remaining = Math.max(0, amount - paid);
    const rowTax = parseFloat(row.field_tax_amount) || 0;
    const tax = (this.taxMode?.hasExclusiveTax && amount > 0 && rowTax > 0)
      ? Math.round(rowTax * (remaining / amount) * 100) / 100
      : 0;
    return { amount: remaining, tax, total: Math.round((remaining + tax) * 100) / 100 };
  }

  get attachedEnrollmentId(): any {
    return this.enrollmentInfo?.id
      || this.injectedDialogData?.event?._def?.extendedProps?.enrollmentInfo?.id
      || null;
  }

  // Package abbreviation (e.g. "BD") for the enrollment chip. Backend populates
  // this in _amt_dayview_getEnrollmentInfo(). Falls back to the enrollment ID
  // when no abbreviation is set on the package.
  get attachedEnrollmentPackageAbbreviation(): string | null {
    return this.enrollmentInfo?.field_package_abbreviation
      || this.injectedDialogData?.event?._def?.extendedProps?.enrollmentInfo?.field_package_abbreviation
      || null;
  }

  lessonBlockFormSubmit(f?, action?) {
    LoggerService.log('lessonBlockFormSubmit called');
    this.displayProgressSpinner(false);
    this.isLoading = true;
    this.activeButton = action === 'email' ? 'email' : 'save';

    // Reset flags at the start
    this.flag1 = false;
    this.flag2 = false;

    // If signatures already exist, mark both flags as complete and proceed
    if (this.eventEntityData?.['field_instructor_signature']?.[0]?.['url'] != null &&
        this.eventEntityData?.['field_signature_student']?.[0]?.['url'] != null) {
      this.flag1 = true;
      this.flag2 = true;
      this.referenceUploadedFileComplete(action);
      return;
    }

    // Handle new signatures
    const uploadSignature = (elementRef: ElementRef<HTMLCanvasElement>, fieldName: string, fileName: string) => {
      return new Promise((resolve, reject) => {
        elementRef.nativeElement.toBlob(blob => {
          // Skip upload if canvas is empty
          if (this.isCanvasEmpty(elementRef.nativeElement)) {
            resolve(null);
            return;
          }

          this._drupalRESTService.uploadFile('events', 'lesson', fieldName, fileName + this.entityID + '.png', blob)
            .subscribe(
              data => {
                if (data['fid']?.[0]?.['value']) {
                  this._entityRESTService.patchEntity('events', 'lesson', this.entityID, {
                    [fieldName]: [{
                      "target_id": data['fid'][0]['value'],
                      "description": ""
                    }]
                  }).subscribe(
                    () => resolve(true),
                    error => reject(error)
                  );
                } else {
                  reject(new Error('No file ID received'));
                }
              },
              error => reject(error)
            );
        });
      });
    };

    // Upload both signatures in parallel
    Promise.all([
      uploadSignature(this.signatureStudent, 'field_signature_student', 'signature_student_lesson_block_'),
      uploadSignature(this.signatureInstructor, 'field_instructor_signature', 'signature_instructor_lesson_block_')
    ]).then(results => {
      this.flag1 = true;
      this.flag2 = true;
      this.referenceUploadedFileComplete(action);
    }).catch(error => {
      LoggerService.error('Error uploading signatures:', error);
      this._snackBar.open('Error saving signatures. Please try again.', 'Close', {
        duration: 5000,
        horizontalPosition: 'center',
        panelClass: ['error-snackbar']
      });
      this.isLoading = false;
      this.activeButton = null;
      this.displayProgressSpinner(false);
    });
  }

  // Add helper method to check if canvas is empty
  private isCanvasEmpty(canvas: HTMLCanvasElement): boolean {
    const context = canvas.getContext('2d');
    const pixelBuffer = new Uint32Array(
      context.getImageData(0, 0, canvas.width, canvas.height).data.buffer
    );
    return !pixelBuffer.some(color => color !== 0);
  }

  referenceUploadedFileComplete(action?) {
    if (!this.flag1 || !this.flag2) {
      return;
    }

    // Save the entity
    this._entityRESTService.patchEntity('events', 'lesson', this.entityID, this.lessonBlockForm.value)
      .subscribe(
        data => {
          LoggerService.log('Entity saved:', data);

          if (action === 'email') {
            // Send the lesson block email
            this.sendLessonBlockEmail();
          } else {
            // Close the dialog
            this.closeDialog();
            this.displayProgressSpinner(false);
            this.isLoading = false;
          }
        },
        error => {
          this.handleError(error);
          this.isLoading = false;
          this.activeButton = null;
          this.displayProgressSpinner(false);
        }
      );
  }

  signatureClearStudent() {
    this.signatureClear(this.signatureStudent);
    this.detectSignatureStudent = false;
  }

  signatureClearInstructor() {
    this.signatureClear(this.signatureInstructor);
    this.detectSignatureInstructor = false;
  }

  signatureClear(elementRef: ElementRef<HTMLCanvasElement>) {
    let canvas = elementRef;

    let context = canvas.nativeElement.getContext('2d');
    context.clearRect(0, 0, context.canvas.width, context.canvas.height)
  }

  signatureInit(elementRef: ElementRef<HTMLCanvasElement>, elementName: string) {
    // Signature Stuff
    let canvas = elementRef;
    let context = canvas?.nativeElement?.getContext('2d');

    if (!context) {
      LoggerService.error('Could not get canvas context for', elementName);
      return;
    };

    context.lineCap = 'round';
    context.strokeStyle = 'black';
    context.lineWidth = 3;

    let x = 0, y = 0;
    let isMouseDown = false;

    // Resize the canvas to match display size
    LoggerService.log(`Canvas ${elementName} before resize:`, canvas.nativeElement.width, canvas.nativeElement.height, canvas.nativeElement.offsetWidth, canvas.nativeElement.offsetHeight);
    canvas.nativeElement.width = canvas.nativeElement.offsetWidth;
    canvas.nativeElement.height = canvas.nativeElement.offsetHeight;
    LoggerService.log(`Canvas ${elementName} after resize:`, canvas.nativeElement.width, canvas.nativeElement.height);

    const stopDrawing = () => { isMouseDown = false; }

    const startDrawing = (event: MouseEvent | TouchEvent) => {
      // Prevent default browser behavior like scrolling
      event.preventDefault();

      isMouseDown = true;

      if (window.TouchEvent && event instanceof TouchEvent) { // Check for TouchEvent support
        const touch = event.touches[0] || event.changedTouches[0];
        x = touch.clientX - canvas.nativeElement.getBoundingClientRect().left;
        y = touch.clientY - canvas.nativeElement.getBoundingClientRect().top;
      } else {
        x = (event as MouseEvent).offsetX;
        y = (event as MouseEvent).offsetY;
      }

      if (elementName === 'student') {
        this.detectSignatureStudent = true;
      }
      if (elementName === 'instructor') {
        this.detectSignatureInstructor = true;
      }
    }

    const drawLine = (event: MouseEvent | TouchEvent) => {
      if (!isMouseDown) return;

      // Prevent default browser behavior like scrolling
      event.preventDefault();

      let newX, newY;

      if (window.TouchEvent && event instanceof TouchEvent) { // Check for TouchEvent support
        const touch = event.touches[0] || event.changedTouches[0];
        newX = touch.clientX - canvas.nativeElement.getBoundingClientRect().left;
        newY = touch.clientY - canvas.nativeElement.getBoundingClientRect().top;
      } else {
        newX = (event as MouseEvent).offsetX;
        newY = (event as MouseEvent).offsetY;
      }

      context.beginPath();
      context.moveTo(x, y);
      context.lineTo(newX, newY);
      context.stroke();
      x = newX;
      y = newY;
    }

    // Add a passive: false option to prevent default scrolling behavior on touch devices
    const addEventOptions = { passive: false };

    // Add event listeners for touch and mouse events
    canvas.nativeElement.addEventListener('mousedown', startDrawing);
    canvas.nativeElement.addEventListener('mousemove', drawLine);
    canvas.nativeElement.addEventListener('mouseup', stopDrawing);
    canvas.nativeElement.addEventListener('mouseleave', stopDrawing);

    canvas.nativeElement.addEventListener('touchstart', startDrawing, addEventOptions);
    canvas.nativeElement.addEventListener('touchmove', drawLine, addEventOptions);
    canvas.nativeElement.addEventListener('touchend', stopDrawing);
    canvas.nativeElement.addEventListener('touchcancel', stopDrawing);

    // Additional pointer events for better compatibility
    canvas.nativeElement.addEventListener('pointerdown', startDrawing);
    canvas.nativeElement.addEventListener('pointermove', drawLine);
    canvas.nativeElement.addEventListener('pointerup', stopDrawing);
    canvas.nativeElement.addEventListener('pointerout', stopDrawing);
  }

  processEventDetails() {
    // eventData is the refreshable copy of extendedProps.eventDetails, so the
    // header date/time updates after an edit instead of showing the old slot.
    const eventDetails = this.eventData;
    if (!eventDetails?.startDate || !eventDetails?.endDate) return;

    const startDate = moment(eventDetails.startDate.join(' '));
    const endDate = moment(eventDetails.endDate.join(' '));

    const processedDetails = {
      date: startDate.format('LL'), // Assuming date is the first element
      startTime: startDate.format('h:mm A'), // Format like "1:00 PM"
      endTime: endDate.format('h:mm A') // Format like "2:00 PM"
    };

    return processedDetails;
  }

  sendLessonBlockEmail() {
    // Get the event ID from the current entity
    const eventID = this.entityID;

    // Make an API call to send the lesson block email
    this._drupalRESTService.httpGET('/api_rest/v1/sendLessonBlockEmail?eventID=' + eventID)
      .subscribe(
        data => {
          LoggerService.log('API response:', data);
          if (data?.['error']) {
            // Handle specific error response
            const errorMessage = data?.['error'];
            this.handleSendEmailError(errorMessage);
          } else {
            // Handle success response
            this._snackBar.open('Email sent successfully.', 'Close', {
              duration: 3000,
              horizontalPosition: 'center',
            });
            // Close the dialog
            this.closeDialog();
            this.displayProgressSpinner(false);
            this.isLoading = false;
          }
        },
        error => {
          LoggerService.error('Error sending email:', error);
          // Handle generic error
          const errorMessage = 'An error occurred while sending the email.';
          this.handleSendEmailError(errorMessage);
        }
      );
  }

  handleSendEmailError(errorMessage: string) {
    // Log the error message
    LoggerService.error('Error sending email:', errorMessage);

    // Display the error message using the snackbar
    this._snackBar.open(errorMessage, 'Close', {
      duration: 5000,
      horizontalPosition: 'center',
      panelClass: 'error-snackbar',
    });

    // Close the dialog
    this.closeDialog();
    this.displayProgressSpinner(false);
    this.isLoading = false;
  }

  sendEmailLessonReminder(eventID: string) {
    LoggerService.log('sendEmailLessonReminder called with eventID:', eventID);
    this._drupalRESTService.httpGET('/api_rest/v1/sendLessonReminderEmail?eventID=' + eventID)
      .subscribe(
        data => {
          LoggerService.log('API response:', data);
          if (data['error']) {
            // Handle specific error response
            const errorMessage = data['error'];
            this._snackBar.open(errorMessage, 'Close', {
              duration: 5000,
              horizontalPosition: 'center',
              panelClass: ['error-snackbar'],
            });
          } else if (data['status'] === 'error') {
            const errorMessage = data['message'] || 'An error occurred while sending the email.';
            this._snackBar.open(errorMessage, 'Close', {
              duration: 5000,
              horizontalPosition: 'center',
              panelClass: ['error-snackbar'],
            });
          } else {
            // Handle success response
            this._snackBar.open('Email sent successfully.', 'Close', {
              duration: 3000,
              horizontalPosition: 'center',
            });
          }
        },
        error => {
          LoggerService.error('Error sending email:', error);
          this._snackBar.open('An error occurred while sending the email.', 'Close', {
            duration: 5000,
            horizontalPosition: 'center',
            panelClass: ['error-snackbar'],
          });
        }
      );
  }


  sendSMSLessonReminder(eventID: string) {
    this._drupalRESTService.httpGET('/api_rest/v1/sendLessonReminderSMS?eventID=' + eventID)
      .subscribe(data => {
        if (data && typeof data === 'object' && 'error' in data) {
          LoggerService.error('Error sending SMS:', data?.['error']);
          const errorMessage = this.formatErrorMessage(data?.['error']);
          // Snackbar message that is centered.
          this._snackBar.open('There was an error. Reason: ' + errorMessage, 'Close', {
            duration: 3000,
            horizontalPosition: 'center',
          });
        } else {
          LoggerService.log('SMS sent:', data);
          // Snackbar message that is centered.
          this._snackBar.open('SMS sent successfully.', 'Close', {
            duration: 3000,
            horizontalPosition: 'center',
          });
        }
      }, error => {
        LoggerService.error('Error sending SMS:', error);
        const errorMessage = this.formatErrorMessage(error);
        // Snackbar message that is centered.
        this._snackBar.open('There was an error. Reason: ' + errorMessage, 'Close', {
          duration: 3000,
          horizontalPosition: 'center',
        });
      });
  }

  private formatErrorMessage(error: any): string {
    if (typeof error === 'string') {
      try {
        const errorObj = JSON.parse(error);
        return errorObj.error || 'Unknown error occurred';
      } catch (e) {
        return error;
      }
    } else if (error && error.message) {
      return error.message;
    }
    return 'Unknown error occurred';
  }

  getFormattedPhoneNumbers(): string {
    const phoneNumbers = this.studentDetails?.studentPhoneNumbers;
    if (phoneNumbers && phoneNumbers.length) {
      return phoneNumbers.map(phone => this.formatPhoneNumber(phone)).join(', ');
    }
    return 'Disabled';
  }

  formatPhoneNumber(phone: string): string {
    const cleaned = ('' + phone).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phone;
  }

  getJoinedStudentNames(): string {
    const studentNames = this.studentDetails?.studentNamesFull;
    return Array.isArray(studentNames)
      ? studentNames.join(', ')
      : 'Not Available';
  }

  convertPotentialLesson() {
    const eventID = this.injectedDialogData?.event?._def?.extendedProps?.eventDetails?.data?.id;
    const data = {
      eventID: eventID
    };

    // Start spinner
    this.isConvertingLesson = true;

    this._drupalRESTService.httpPOST('/api_rest/v1/convertPotentialLesson', data)
      .subscribe(
        response => {
          LoggerService.log('Conversion response:', response);
          // Stop spinner
          this.isConvertingLesson = false;

          if (response.success) {
            // Handle success scenario
            this._snackBar.open('Potential lesson converted successfully.', 'Close', {
              duration: 3000,
              horizontalPosition: 'center',
            });
            // Refresh the calendar or perform any other necessary actions
            this.eventDeleted.emit();
            this.closeDialog();
          } else {
            // Handle error scenario with a specific error message
            const errorMessage = response.message || 'Failed to convert potential lesson.';
            this._snackBar.open(errorMessage, 'Close', {
              duration: 5000,
              horizontalPosition: 'center',
              panelClass: ['error-snackbar'],
            });
          }
        },
        error => {
          LoggerService.error('Conversion error:', error);
          // Stop spinner on error
          this.isConvertingLesson = false;

          // Handle generic error scenario
          this._snackBar.open('An error occurred while converting the potential lesson.', 'Close', {
            duration: 5000,
            horizontalPosition: 'center',
            panelClass: ['error-snackbar'],
          });
        }
      );
  }

  private setInstructorPercentages(enrollmentComponent: EnrollmentEntityComponent, studentData: any) {
    if (studentData?.['field_teacher']?.uid) {
      const instructorPercentagesArray = enrollmentComponent.enrollmentForm.get('field_instructor_percentages') as FormArray;

      // Clear existing entries
      while (instructorPercentagesArray.length !== 0) {
        instructorPercentagesArray.removeAt(0);
      }

      // Add new entry
      const newInstructorPercentage = this._formBuilder.group({
        id: [null],
        field_amount: [null],
        field_instructor: [studentData['field_teacher'].uid, Validators.required],
        field_percentage: [100, Validators.required],
        field_studio_reference: [this._authService.selectedStudio?.id],
        bundle: ['instructor_percentages', Validators.required],
        type: ['instructor_percentages', Validators.required],
      });

      instructorPercentagesArray.push(newInstructorPercentage);

      // Trigger change detection
      enrollmentComponent.enrollmentForm.updateValueAndValidity();
      LoggerService.log('Updated enrollment form:', enrollmentComponent.enrollmentForm.value);
    }
  }

  openEnrollment() {
    const studentAccountId = this.studentDetails?.studentAccountId;
    const studentDisplayName = this.studentDetails?.StudentDisplayName;

    if (!studentAccountId || !studentDisplayName) {
      LoggerService.error('Student account ID or display name is undefined');
      // You might want to show an error message to the user here
      return;
    }

    this._entityRESTService.getEntity('student_accounts', 'student_account', studentAccountId)
      .subscribe(
        studentData => {
          const fieldsData = {
            field_student: `${studentDisplayName} (${studentAccountId})`,
            field_executive: studentData?.['field_executive']?.uid || '',
            // field_sale_date deliberately not prefilled: the enrollment form
            // fills it with studio-timezone "now" when the field is focused,
            // and the expiration date auto-derives from it (+6 months).
            field_enrollment_package_name: null,
            field_enrollment_lesson_price: null,
            field_enrollment_lesson_count: null,
            field_enrollment_total_price: null,
            field_total_price_with_est_tax: null,
            field_tax_percentage: null,
            field_discount: 0,
            field_discount_type: 'flat',
            field_enrollment_status: 'Open',
            field_visibility: false
          };

          LoggerService.log('Enrollment fields data:', fieldsData);

          const dialogRef = this.openEntityComponent(
            EnrollmentEntityComponent,
            'packages',
            'enrollment',
            'create',
            null,
            fieldsData
          );

          dialogRef.afterOpened().subscribe(() => {
            const enrollmentComponent = dialogRef.componentInstance as EnrollmentEntityComponent;
            if (enrollmentComponent && enrollmentComponent.enrollmentForm) {
              this.setInstructorPercentages(enrollmentComponent, studentData);
            }
          });
        },
        error => {
          LoggerService.error('Error fetching student data:', error);
          // You might want to show an error message to the user here
        }
      );
  }

  openLesson() {
    const studentAccountId = this.studentDetails?.studentAccountId;
    const studentDisplayName = this.studentDetails?.StudentDisplayName;

    if (!studentAccountId || !studentDisplayName) {
      LoggerService.error('Student account ID or display name is undefined');
      this._snackBar.open('Unable to open lesson: Student information is missing', 'Close', {
        duration: 3000,
        horizontalPosition: 'center',
        panelClass: ['warning-snackbar']
      });
      return;
    }

    // Show loading indicator
    // this.isLoading = true;
    this._snackBar.open('Checking for available enrollments...', '', {
      duration: 2000,
      horizontalPosition: 'center'
    });

    const studentIdentifier = `${studentDisplayName} (${studentAccountId})`;

    // First, get the student account data
    this._entityRESTService.getEntity('student_accounts', 'student_account', studentAccountId)
      .subscribe(
        studentData => {
          // Now, get the enrollment data
          const endpoint = "/api_rest/v1/enrollmentLookupDetailed";
          const params = [{ parameter: "u", value: studentAccountId }];

          this._drupalRESTService.httpGET(endpoint, params)
            .subscribe(
              enrollmentData => {
                const dataObj = Object.values(enrollmentData);
                this.isLoading = false;

                // Check if there are any enrollments at all
                if (!dataObj || dataObj.length === 0) {
                  this._snackBar.open('No enrollments found for this student. Please create an enrollment first.', 'Create Enrollment', {
                    duration: 6000,
                    horizontalPosition: 'center',
                    panelClass: ['warning-snackbar']
                  }).onAction().subscribe(() => {
                    this.openEntityComponent(
                      this.EnrollmentEntityComponent,
                      'enrollments',
                      'enrollment',
                      'create',
                      null,
                      {
                        'field_student_name': `${studentDisplayName} (${studentAccountId})`
                      }
                    );
                  });
                  return;
                }

                // Filter enrollments
                const availableEnrollments = dataObj.filter(object => {
                  const isNotDropped = !(object.field_drop[0]?.value == object.field_balance_due[0]?.value);
                  // Check for lessons remaining on contract (enrolled - used), not just paid lessons available
                  const lessonsRemaining = (parseFloat(object.field_enrollment_lesson_count[0]?.value) || 0)
                                         - (parseFloat(object.field_lesson_used[0]?.value) || 0);
                  const hasLessonsOnContract = lessonsRemaining > 0;
                  const isSundryOrMisc = (object?.field_category?.[0]?.target_id == 67) || (object.field_category[0].target_id == 5);

                  return hasLessonsOnContract && isNotDropped && !isSundryOrMisc;
                });

                // Sort enrollments by sale date and get the oldest one
                availableEnrollments.sort((a, b) => {
                  const dateA = new Date(a.field_sale_date[0].value);
                  const dateB = new Date(b.field_sale_date[0].value);
                  return dateA.getTime() - dateB.getTime();
                });

                const oldestEnrollment = availableEnrollments[0];

                if (!oldestEnrollment) {
                  // Show a more informative message with options for the user
                  this.isLoading = false;

                  // Check if there are any enrollments at all, but none are available for lessons
                  if (dataObj.length > 0) {
                    this._snackBar.open('Student has enrollments, but none are available for lessons. They may be fully used, have a balance due, or be of a type that doesn\'t include lessons.', 'Create Enrollment', {
                      duration: 8000,
                      horizontalPosition: 'center',
                      panelClass: ['warning-snackbar']
                    }).onAction().subscribe(() => {
                      this.openEntityComponent(
                        this.EnrollmentEntityComponent,
                        'enrollments',
                        'enrollment',
                        'create',
                        null,
                        {
                          'field_student_name': `${studentDisplayName} (${studentAccountId})`
                        }
                      );
                    });
                  } else {
                    this._snackBar.open('No available enrollments found for this student. Please create an enrollment first.', 'Create Enrollment', {
                      duration: 6000,
                      horizontalPosition: 'center',
                      panelClass: ['warning-snackbar']
                    }).onAction().subscribe(() => {
                      // When the user clicks "Create Enrollment", open the enrollment form
                      this.openEntityComponent(
                        this.EnrollmentEntityComponent,
                        'enrollments',
                        'enrollment',
                        'create',
                        null,
                        {
                          'field_student_name': `${studentDisplayName} (${studentAccountId})`
                        }
                      );
                    });
                  }
                  return;
                }

                // Prepare the fields data for the lesson
                const fieldsData = {
                  field_instructor: this.injectedDialogData?.event?._def?.extendedProps?.instructorID,
                  field_type: this.injectedDialogData?.event?._def?.extendedProps?.eventDetails?.data?.eventTypeID,
                  field_duration: this.injectedDialogData?.event?._def.extendedProps?.eventDetails?.data?.eventDuration,
                  field_date_and_time: this.roundToNearest15Min(),
                  field_status: '58', // Assuming '58' is the status for a new lesson
                  field_studio_reference: this._authService.selectedStudio?.id,
                  __field_students_inline_form: {
                    type: 'attendees',
                    bundle: 'attendance',
                    field_student_account: studentIdentifier,
                    field_enrollment: oldestEnrollment.id[0].value,
                  }
                };

                // Open the EventLessonEntityComponent dialog
                const dialogRef = this.openEntityComponent(
                  EventLessonEntityComponent,
                  'events',
                  'lesson',
                  'create',
                  null,
                  fieldsData
                );

                this.isLoading = false;

                dialogRef.afterOpened().subscribe(() => {
                  const lessonComponent = dialogRef.componentInstance as EventLessonEntityComponent;
                  if (lessonComponent && lessonComponent.f) {
                    // Implement lookupStudentAccountContact logic
                    let contacts = "";
                    let contactsID = [];
                    let tmp = [];
                    let selectOptions = [];

                    if (Array.isArray(studentData['field_contacts'])) {
                      studentData['field_contacts'].forEach(element => {
                        contactsID.push(element.id);
                        tmp.push(element.title + ' (' + element.id + ')');
                        selectOptions.push({ id: element.id, title: element.title });
                      });

                      contacts = tmp.join(', ');
                      selectOptions.push({ id: contactsID.toString(), title: contacts });
                    } else {
                      selectOptions.push({ id: studentData['field_contacts'].id, title: studentData['field_contacts'].title });
                      contacts += studentData['field_contacts'].title + ' (' + studentData['field_contacts'].id + ')';
                    }

                    lessonComponent.autoCompleteStudentContactOptions = selectOptions;
                    lessonComponent.f.form.controls['__field_students_inline_form'].patchValue({
                      field_students_contact: contacts
                    });

                    // Automatically select the last contact (the couple) for field_students
                    if (selectOptions.length > 0) {
                      const lastContactId = selectOptions[selectOptions.length - 1].id;
                      lessonComponent.f.form.controls['__field_students_inline_form'].patchValue({
                        field_students: lastContactId
                      });

                      // Set field_type based on field_student_department
                      const studentDepartment = studentData['field_student_department'];
                      if (studentDepartment == 75) {
                        lessonComponent.f.form.patchValue({
                          field_type: "548"
                        });
                      } else if (studentDepartment == 77) {
                        lessonComponent.f.form.patchValue({
                          field_type: "600"
                        });
                      }
                    }
                  }
                });
              },
              error => {
                LoggerService.error('Error fetching enrollment data:', error);
                this.isLoading = false;
                this._snackBar.open('Unable to find enrollments. Please check if the student has any active enrollments.', 'Create Enrollment', {
                  duration: 5000,
                  horizontalPosition: 'center',
                  panelClass: ['warning-snackbar']
                }).onAction().subscribe(() => {
                  // When the user clicks "Create Enrollment", open the enrollment form
                  this.openEntityComponent(
                    this.EnrollmentEntityComponent,
                    'enrollments',
                    'enrollment',
                    'create',
                    null,
                    {
                      'field_student_name': `${studentDisplayName} (${studentAccountId})`
                    }
                  );
                });
              }
            );
        },
        error => {
          LoggerService.error('Error fetching student data:', error);
          this.isLoading = false;
          this._snackBar.open('Unable to load student information. Please try again or check if the student exists.', 'Close', {
            duration: 5000,
            horizontalPosition: 'center',
            panelClass: ['warning-snackbar']
          });
        }
      );
  }

  onTabChanged(event: MatTabChangeEvent) {
    LoggerService.log('Tab changed:', event.tab.textLabel);

    this.pinDialogTop();

    // Set active tab flag
    this.isLessonBlocksTabActive = (event.tab.textLabel === 'Lesson Blocks');
    this.isDetailsTabActive = (event.tab.textLabel === 'Details');

    // Check if we're switching to the Lesson Blocks tab
    if (this.isLessonBlocksTabActive) {
      LoggerService.log('Lesson Blocks tab selected, reinitializing signatures');

      // Wait for the DOM to update after tab change
      setTimeout(() => {
        if (this.signatureStudent?.nativeElement) {
          LoggerService.log('Reinitializing student signature');
          this.signatureInit(this.signatureStudent, 'student');
        }

        if (this.signatureInstructor?.nativeElement) {
          LoggerService.log('Reinitializing instructor signature');
          this.signatureInit(this.signatureInstructor, 'instructor');
        }
      });
    }

    // Check if we're switching to the Edit Status tab for group lessons
    if (event.tab.textLabel === 'Edit Status' &&
        this.injectedDialogData?.event?._def?.extendedProps?.appointmentType === 'group_lesson') {
      // Refresh the data
      this.updateStatusGroupLesson?.loadEventData();
    }
  }

  /**
   * Tabs differ a lot in height, and a vertically centered dialog jumps up or
   * down on every switch. selectedTabChange fires before the new tab body is
   * rendered, so the pane still sits where the user sees it: pin its top there
   * so only the bottom edge moves. offsetTop ignores the cdkDrag transform.
   */
  private pinDialogTop(): void {
    const pane = (this._el.nativeElement as HTMLElement).closest('.cdk-overlay-pane') as HTMLElement | null;
    if (!pane) {
      return;
    }
    const margin = 16;
    this._dialogRef.updatePosition({ top: `${Math.max(margin, pane.offsetTop)}px` });

    // If the new tab is taller than the space left below, slide up just enough to fit.
    requestAnimationFrame(() => {
      const overflow = pane.offsetTop + pane.offsetHeight + margin - window.innerHeight;
      if (overflow > 0) {
        this._dialogRef.updatePosition({ top: `${Math.max(margin, pane.offsetTop - overflow)}px` });
      }
    });
  }

  /**
   * Refreshes appointment data after changes in Student Dashboard
   * TODO: Create a dedicated API endpoint to fetch single event data instead of all events
   * Current implementation fetches all calendar events and filters - inefficient but works
   */
  private refreshAppointmentData(): void {
    this.isRefreshing = true;

    if (this.appointmentType === 'lesson' && this.entityID) {
      // Load the lesson entity first: an edit may have moved the lesson to a
      // different day, and the calendar lookup below searches a single day.
      // Searching the day the dialog was opened with would silently find
      // nothing and leave every panel stale.
      this.loadLessonData(this.entityID).subscribe(
        (data) => {
          this.eventEntityData = data;
          LoggerService.log('Refreshed eventEntityData:', data);

          const freshDate = this.extractLessonDate(data);
          this.fetchFreshEventData(freshDate);
        },
        (error) => {
          LoggerService.error('Error refreshing lesson entity, falling back to original date:', error);
          this.fetchFreshEventData();
        }
      );
      return;
    }

    // Fetch fresh calendar event data. It refreshes the upcoming events list
    // once done. That list needs the refreshed student details, so it must
    // not run concurrently.
    this.fetchFreshEventData();
  }

  /**
   * Pulls the lesson date out of a collapsed lesson entity. The collapse API
   * returns field_date_and_time as a plain string, but tolerate the raw
   * [{value}] shape too.
   */
  private extractLessonDate(entityData: any): string | null {
    const raw = entityData?.field_date_and_time;
    if (!raw) {
      return null;
    }
    if (typeof raw === 'string') {
      return raw;
    }
    if (Array.isArray(raw)) {
      const first = raw[0];
      return typeof first === 'string' ? first : first?.value || null;
    }
    return raw?.value || null;
  }

  /**
   * Fetches fresh event data from the calendar API
   * TODO: This currently fetches ALL events for the day - create dedicated endpoint for single event
   */
  private fetchFreshEventData(overrideDate?: string | Date | null): void {
    // Try multiple locations for entityId
    const entityId = this.entityID ||
                     this.injectedDialogData?.event?._def?.extendedProps?.entityId ||
                     this.injectedDialogData?.event?.extendedProps?.entityId;

    // Prefer the entity's current date (the edit may have rescheduled it);
    // fall back to the date the dialog was opened with.
    const eventDate = overrideDate ||
                      this.injectedDialogData?.event?.start ||
                      this.injectedDialogData?.event?._instance?.range?.start ||
                      this.injectedDialogData?.event?._def?.recurringDef?.typeData?.startTime;

    LoggerService.log('[fetchFreshEventData] Looking for entityId:', entityId);
    LoggerService.log('[fetchFreshEventData] Looking for eventDate:', eventDate);
    LoggerService.log('[fetchFreshEventData] Full injectedDialogData:', this.injectedDialogData);

    if (!entityId || !eventDate) {
      LoggerService.warn('Cannot refresh: missing entityId or eventDate');
      LoggerService.log('Available entityID:', this.entityID);
      LoggerService.log('Available injectedDialogData:', this.injectedDialogData);
      this.isRefreshing = false;
      return;
    }

    // Use the CalendarDataService to fetch events
    // TODO: Use fetchSingleEvent when a dedicated endpoint is available
    LoggerService.log('Fetching ALL calendar events for the day (inefficient but temporary)');
    LoggerService.log('TODO: Create dedicated endpoint for single event fetch');

    this.calendarDataService.fetchCalendarEvents(eventDate, eventDate, eventDate).subscribe(
      (response: any) => {
        LoggerService.log('Full calendar events response:', response);

        // The response should contain all events for the day
        // Events are typically in the root array or response.events
        let events = Array.isArray(response) ? response : (response?.events || []);

        LoggerService.log(`Found ${events.length} total events for the day`);

        // Find our specific event in the response by matching entityId
        const freshEvent = events.find((e: any) => {
          // The entityId might be in different places depending on the API response structure
          const eventEntityId = e.extendedProps?.entityId ||
                               e.entityId ||
                               e.id ||
                               e._def?.extendedProps?.entityId;

          const matches = eventEntityId == entityId || eventEntityId === entityId.toString();
          if (matches) {
            LoggerService.log('Found matching event:', e);
          }
          return matches;
        });

        if (freshEvent) {
          LoggerService.log('Found fresh event data:', freshEvent);
          // Update local copy with fresh data
          this.updateLocalEventData(freshEvent);
        } else {
          LoggerService.warn('Could not find event with entityId:', entityId, 'in', events.length, 'events');
          LoggerService.log('Looking for entityId:', entityId);
          LoggerService.log('Available events:', events.map(e => ({
            id: e.id,
            entityId: e.extendedProps?.entityId || e.entityId,
            title: e.title
          })));
        }
        this.isRefreshing = false;

        // Refresh the upcoming events list after the local student details
        // have been updated. It reads this.studentDetails for the account id.
        this.fetchUpcomingEvents(eventDate);
      },
      (error) => {
        LoggerService.error('Error refreshing event data:', error);
        this._snackBar.open('Failed to refresh appointment data', 'Close', {
          duration: 3000,
          panelClass: ['error-snackbar']
        });
        this.isRefreshing = false;
        this.fetchUpcomingEvents(eventDate);
      }
    );
  }

  /**
   * Fetches upcoming events list using the CalendarDataService
   */
  private fetchUpcomingEvents(overrideDate?: string | Date | null): void {
    // Use the refreshed student details. An edit may have switched the
    // student, and the injected copy always holds the original one.
    const studentAccountId = this.studentDetails?.studentAccountId ||
                            this.injectedDialogData?.event?._def?.extendedProps?.studentDetails?.studentAccountID ||
                            this.injectedDialogData?.event?._def?.extendedProps?.studentAccountID;

    // Prefer the entity's current date (the edit may have rescheduled it).
    const eventDate = overrideDate ||
                      this.injectedDialogData?.event?.start ||
                      this.injectedDialogData?.event?._instance?.range?.start ||
                      this.injectedDialogData?.event?._def?.recurringDef?.typeData?.startTime;

    if (!this.entityID || !eventDate) {
      LoggerService.warn('Cannot fetch upcoming events: missing entityID or eventDate');
      return;
    }

    // Use the service to fetch next events
    this.calendarDataService.fetchNextEvents(this.entityID, eventDate, studentAccountId).subscribe(
      (data: any) => {
        LoggerService.log('[fetchUpcomingEvents] Received data:', data);
        if (data && data.upcomingEventList) {
          this.upcomingEventList = data.upcomingEventList;
          LoggerService.log('[fetchUpcomingEvents] Updated upcomingEventList with', data.upcomingEventList.length, 'events');
        } else {
          this.upcomingEventList = [];
          LoggerService.log('[fetchUpcomingEvents] No upcoming events found');
        }
        // Trigger change detection to avoid ExpressionChangedAfterItHasBeenCheckedError
        this._changeDetectorRef.detectChanges();
      },
      (error) => {
        LoggerService.error('[fetchUpcomingEvents] Error fetching upcoming events:', error);
        // Don't clear the existing list on error
      }
    );
  }

  /**
   * Updates local component properties with fresh event data
   */
  private updateLocalEventData(freshEvent: any): void {
    // Store the refreshed data
    this.refreshedEventData = freshEvent.extendedProps || freshEvent;
    const extProps = freshEvent.extendedProps || freshEvent;

    // Update all refreshable properties
    if (extProps.studentInfo) {
      this.studentInfo = extProps.studentInfo;
      LoggerService.log('Updated studentInfo:', this.studentInfo);
    }

    if (extProps.instructorName) {
      this.instructorName = extProps.instructorName;
    }

    if (extProps.enrollmentInfo) {
      this.enrollmentInfo = extProps.enrollmentInfo;
    }

    // Only update upcomingEventList if it's explicitly provided
    // Otherwise it will be fetched separately via fetchUpcomingEvents()
    if (extProps.upcomingEventList && extProps.upcomingEventList.length > 0) {
      this.upcomingEventList = extProps.upcomingEventList;
    }

    if (extProps.studentDetails) {
      this.studentDetails = extProps.studentDetails;
    }

    // Update boolean flags
    this.isStanding = extProps.isStanding ?? this.isStanding;
    this.isConfirmed = extProps.isConfirmed ?? this.isConfirmed;
    this.notificationSent = this.toBool(extProps.field_24_hour_notification_sent) ||
                           this.toBool(extProps.field_48_hour_notification_sent) ||
                           this.toBool(extProps.field_72_hour_notification_sent);

    // Update notes
    if (extProps.eventDetails?.data?.field_notes) {
      this.eventNotes = extProps.eventDetails.data.field_notes;
    }

    // Update component properties that template uses
    if (extProps.eventDetails) {
      const eventDetails = extProps.eventDetails;
      this.eventData = eventDetails;

      // Update student dashboard status data
      if (eventDetails.studentsDashboardStatus?.[0]) {
        const status = eventDetails.studentsDashboardStatus[0];
        this.attendeesID = status.attendees_id;
        this.studentName = status.name;
        this.eventID = status.entity_id;
        this.status = status.status;
      }
    }

    // Show success message
    this._snackBar.open('Appointment data refreshed', 'Close', {
      duration: 2000,
      panelClass: ['success-snackbar']
    });
  }

  /**
   * Coerce a backend flag to a real boolean. The backend now sends true
   * booleans, but older/other code paths can still emit the string '0',
   * which is truthy in JS. Treat '0'/'false' as false so a "not sent"
   * flag never renders as "reminder sent".
   */
  private toBool(value: any): boolean {
    if (typeof value === 'string') {
      return value !== '' && value !== '0' && value.toLowerCase() !== 'false';
    }
    return !!value;
  }
}
